export default __webpack_public_path__ + "static/google-play-42ba0f96a04aa8dc589cb8fdf954b609.png";